import axios from '../plugins/axios';

const API_URL = '/admin/coffee-breaks';

export default {
  async getBreaks(filters = {}) {
    let url = API_URL;
    
    if (filters.name) {
      url += `?_filters_[]=name__contains&name__contains=${encodeURIComponent(filters.name)}`;
    }
    
    console.log('API Request URL:', url);
    
    try {
      const response = await axios.get(url);
      console.log('API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  },

  async addBreak(breakData) {
    const response = await axios.post(API_URL, breakData);
    return response.data;
  },

  async updateBreak(breakId, breakData) {
    const response = await axios.put(`${API_URL}/${breakId}`, breakData);
    return response.data;
  },

  async deleteBreak(breakId) {
    const response = await axios.delete(`${API_URL}/${breakId}`);
    return response.data;
  }
}; 